import React, { useState } from "react"
import { useFormikContext } from "formik"

import FormError from "../../../formError"

const AdditionalDocuments = () => {
  const { values, errors, touched, setFieldValue } = useFormikContext()

  const [image, setImage] = useState("")
  const [url, setUrl] = useState("")
  const [loading, setLoading] = useState(false)

  const uploadImage = (file_data, file_location) => {
    setLoading(true)
    const data = new FormData()
    data.append("file", file_data)
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/FileUpload`, {
      method: "post",
      body: data,
    })
      .then((resp) => resp.json())
      .then((data) => {
        // setUrl(data.url)
        setFieldValue(file_location, data.resp)
        setFieldValue(`${file_location}_name`, file_data.name)
        setLoading(false)
      })
      .catch((err) => console.log(err))
  }

  const setFile = (file, location) => {
    uploadImage(file, location)
  }

  return (
    <div
      className={
        loading
          ? "progress_state form-row justify-content-center"
          : "form-row justify-content-center"
      }
    >
      <div className="form-group col-md-12">
        <label htmlFor="certificate_of_registration">
          A copy of your Certificate of registration{" "}
        </label>
        <input
          type="file"
          className="form-control border-0"
          id="certificate_of_registration"
          name="certificate_of_registration"
          accept="application/pdf"
          title="Accepts pdf file only"
          onChange={(e) =>
            setFile(e.target.files[0], "certificate_of_registration")
          }
        />

        <label
          htmlFor="certificate_of_registration"
          className="font-weight-light text-muted"
        >
          pdf file only
        </label>

        <p>
          {values.certificate_of_registration > 1 &&
            values.certificate_of_registration.file.name}
        </p>

        <FormError
          touched={touched.certificate_of_registration}
          message={errors.certificate_of_registration}
        />
      </div>

      <p>{loading && "Uploading"}</p>
    </div>
  )
}

export default AdditionalDocuments
